module.exports = __webpack_public_path__ + "img/wenzi2.c8139c67.svg";